import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { AutenticacionService } from './autenticacion.service';
import { EstructuraFisicaUsuariosProcesos } from '../_models/estructura-fisica-usuarios-procesos';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class EstructuraFisicaUsuariosProcesosService {

  private rutServicio = AppSettings.rutServiciosRG + '/api/estructuraFisicaUsuariosProcesos/';

  constructor( private httpClient: HttpClient, private autServicio: AutenticacionService ) { }


  listado() {
    return this.httpClient.get( this.rutServicio ).pipe( map( res => res as EstructuraFisicaUsuariosProcesos[] ) );
  }

  listadoHabilitado() {
    return this.httpClient.get( this.rutServicio + 'enabled' ).pipe( map( res => res as EstructuraFisicaUsuariosProcesos[] ) );
  }

  listadoPorIdEstructuraFisica(idEstructuraFisica: string) {
    return this.httpClient.get( `${this.rutServicio}estructuraFisica/${idEstructuraFisica}/aprobacion` ).pipe( map( res => res as EstructuraFisicaUsuariosProcesos[] ) );
  }

  obtenerPorId( id: string ) {
    return this.httpClient.get( this.rutServicio + id ).pipe( map( res => res as EstructuraFisicaUsuariosProcesos ) );
  }

  crear( c: EstructuraFisicaUsuariosProcesos ) {
    c.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httpClient.post( this.rutServicio, c ).pipe( map( res => res as any ) );
  }

  actualizar( c: EstructuraFisicaUsuariosProcesos ) {
    c.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httpClient.put( this.rutServicio, c ).pipe( map( res => res as any ) );
  }

  bulk( regActualizar: EstructuraFisicaUsuariosProcesos[] ) {
    regActualizar.map( ( s: EstructuraFisicaUsuariosProcesos ) => {
      s.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    } );
    return this.httpClient.post( this.rutServicio + 'bulk', regActualizar ).pipe( map( res => res as EstructuraFisicaUsuariosProcesos[] ) );
  }

}
